import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardLayout from "./components/AdminDashboard/DashboardLayout";
import ProtectedRoute from "./components/AdminDashboard/ProtectedRoute";
import "./App.css";
import LandingPage from "./components/Landing/LandingPage";


import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import GlobalNetwork_Register from "./pages/GlobalNetwork_Register";

import CurrentJobsview from "./pages/Currentjobsview";
import Upcommingevents from "./pages/Upcommingevents";
import Pastcompletedevents from "./pages/Pastcompletedevents";


import HrDashboardLayout from "./components/HrDashBoard/HrDashboardLayout";



import StudentDashboardLayout from "./components/Student/StudentDashboardLayout";

import Blackprofilelanding from "../src/components/Blockprofilelanding";

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";




function App() {
  return (
    <div className="App">

 <ToastContainer
        position="top-center"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        {/* Dashboard Layout with nested routes */}
       <Route
  path="/dashboard/*"
  element={
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  }
/>


        {/* <Route path="/hrdashboard/*" element={<HrDashboardRoutes />} /> */}
        <Route path="/hrdashboard/*" element={<HrDashboardLayout />} />

        <Route path="/CurrentJobsview/" element={<CurrentJobsview />} />

        <Route path="/Upcommingevents/" element={<Upcommingevents />} />
        <Route path="/Pastcompletedevents/" element={<Pastcompletedevents />} />

        <Route path="Upcommingevents" element={<Upcommingevents />} />
        <Route path="Pastcompletedevents" element={<Pastcompletedevents />} />

        {/* Dashboard Layout of student  with nested routes */}
        <Route path="/student/*" element={<StudentDashboardLayout />} />


        <Route path="/Blackprofilelanding/" element={<Blackprofilelanding />} />

      </Routes>

      {/* <GlobalNetwork_Register/> */}



    </div>
  );
}

export default App;
